<style lang="postcss">
	.breadcrumbs-ol {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-self: start;
		max-width: 100%;
		font-size: inherit;
		margin-bottom: 0.75rem;
		padding: 0;
	}
	.breadcrumbs-ol.seamless {
		margin-top: 0;
		margin-bottom: 0;
	}
	.breadcrumbs-ol li {
		display: inline-flex;
		flex-flow: row nowrap;
		align-items: center;
		min-width: 0;
		white-space: nowrap;
	}
	.breadcrumbs-ol li.hide-mobile {
		display: none;
	}
	.arrow-right {
		padding: 0 0.25rem;
	}
	.hide-if-long {
		vertical-align: middle;
	}
	@media (max-width: 768px) {
		.breadcrumbs-ol {
			flex: 1 1 0%;
			min-width: 0;
			letter-spacing: -0.25px;
		}
		.breadcrumbs-ol li:last-child {
			flex: 1 1 0%;
			min-width: 0;
			white-space: nowrap;
		}
		.breadcrumbs-ol li:last-child > span {
			display: inline-block;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: 100%;
		}
		.arrow-right {
			padding: 0 0.2rem;
		}
	}
	@media (min-width: 768px) {
		.breadcrumbs-ol {
			margin-bottom: 0.5rem;
		}
		.breadcrumbs-ol li.hide-mobile {
			display: inline-flex;
		}
		.arrow-right {
			opacity: 0.7;
		}
	}
</style>

<script lang="ts">
	export let data: Breadcrumb[] = [];
	export let seamless = false;
	import { page } from "$app/stores";
	function skipLink(item: Breadcrumb) {
		return item.link === $page.url.pathname + $page.url.search;
	}
</script>

{#if data.length}
	<ol
		aria-label="breadcrumbs"
		class:seamless="{seamless}"
		style="{$$props.style ?? ''};"
		class="breadcrumbs-ol {$$props.class ?? ''}">
		{#each data as item, index}
			{@const isLast = index === data.length - 1}
			{@const isFirst = index === 0}
			{@const skip = skipLink(item)}
			<li
				class:hidden="{item.hidden}"
				class:hide-mobile="{item.hideOnMobile === true}"
				class="not-prose {$$props.itemClass ?? ''}">
				{#if !isFirst}
					<div class="arrow-right">›</div>
				{/if}
				{#if skip}
					<span
						style="color: #6f737c"
						class="px-0.5 gap-1 not-prose inline-flex">
						{#if item.shortText}
							<span class="inline-block md:hidden">{item.shortText}</span>
							<span class="hidden md:inline-block">{item.text}</span>
						{:else}
							<span class="">
								{item.text}
							</span>
						{/if}
					</span>
				{:else}
					<a
						href="{item.link}"
						class="hover:text-blue-600 px-0.5 gap-1 not-prose">
						<span class="inline-flex">
							{#if item.shortText}
								<span class="inline-block md:hidden hide-if-long"
									>{item.shortText}</span>
								<span class="hidden md:inline-block hide-if-long"
									>{item.text}</span>
							{:else}
								<span class="hide-if-long">
									{item.text}
								</span>
							{/if}
						</span>
					</a>
				{/if}
			</li>
		{/each}
	</ol>
{/if}
